import { defineMessages } from 'react-intl';


const CHEQUING_TYPES = {
    ALL: 'all',
    PERSONAL: 'personal',
    STUDENT: 'student',
    YOUTH: 'youth',
    SENIOR: 'senior',
};

const MESSAGES = defineMessages({
    [CHEQUING_TYPES.ALL]: {
        id: 'edb.chequing.type.all',
        defaultMessage: 'All',
    },
    [CHEQUING_TYPES.PERSONAL]: {
        id: 'edb.chequing.type.personal',
        defaultMessage: 'Personal',
    },
    [CHEQUING_TYPES.STUDENT]: {
        id: 'edb.chequing.type.student',
        defaultMessage: 'Student',
    },
    [CHEQUING_TYPES.YOUTH]: {
        id: 'edb.chequing.type.youth',
        defaultMessage: 'Youth',
    },
    [CHEQUING_TYPES.SENIOR]: {
        id: 'edb.chequing.type.senior',
        defaultMessage: 'Senior',
    },
});


const CHEQUING_TYPES_OPTIONS = Object.values(CHEQUING_TYPES).map(value => ({
    value: value,
    label: MESSAGES[value],
}));


export { CHEQUING_TYPES };
export default CHEQUING_TYPES_OPTIONS;
